<p>edit-attendance works!</p>
